/* eslint-disable @typescript-eslint/no-unused-vars */
/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable jsx-a11y/click-events-have-key-events */
import React, { useMemo } from 'react';
import arrowLeft from 'images/arrow/arrow_left.png';
import arrowRight from 'images/arrow/arrow_right.png';

export interface MonthNavigationProps {
  date: Date;
  onChange: (v: Date) => void;
  infinite?: boolean;
  maxYear?: number;
  onChangePrevious?: (v: Date) => void;
  onChangeNext?: (v: Date) => void;
}

const isNextYearBlocked = (currentDate: Date, maxYear?: number) => {
  if (!maxYear) {
    return false;
  }

  return currentDate.getFullYear() >= maxYear;
};

const MonthNavigation = ({ date, infinite, maxYear, onChange, onChangePrevious, onChangeNext }: MonthNavigationProps) => {
  const handlePrevious = () => {
    const previousDate = new Date(date);
    previousDate.setFullYear(date.getFullYear() - 1);

    onChange(previousDate);
    onChangePrevious?.(previousDate);
  };

  const handleNext = () => {
    if (!infinite && isNextYearBlocked(date, maxYear)) {
      return;
    }

    const nextDate = new Date(date);
    nextDate.setFullYear(date.getFullYear() + 1);

    onChange(nextDate);
    onChangeNext?.(nextDate);
  };

  const rightBtn = useMemo(() => {
    if (!infinite && isNextYearBlocked(date, maxYear)) return 'right_disabled';
    return 'right';
  }, [date, infinite, maxYear]);

  return (
    <div className="navigation">
      <div className="left" onClick={handlePrevious}>
        <img src={arrowLeft} alt="prev_button_icon" className="arrowicon" /> 전년
      </div>
      <div className="center">{date.getFullYear()}</div>
      <div className={rightBtn} onClick={handleNext}>
        <span className="string">
          내년 <img src={arrowRight} alt="next_button_icon" className="arrowicon" />
        </span>
      </div>
    </div>
  );
};

export default MonthNavigation;
